import { IYearMonth } from '@/coreDomainsModule/date';
import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { CustomerForecastRepository } from '@/coreInfrastructureModule/Repositories/CustomerForecastRepository';
import { ICustomerForecastTimeline } from '../domains/entities/customerForecastTimeline';
import { BulkGetCustomerForecastTimelineAdapter } from '../adapter/bulkGetCustomerForecastTimelineAdapter';

/**
 * 前月内示差異画面の情報を取得する
 */
export class BulkGetCustomerForecastTimelineUseCase {
  /**
   * APIを叩き、関連取引の前月内示遍歴情報を取得する
   * @param repository - 取引情報のリポジトリ
   * @param baseBusinessId - 関連取引ID
   * @param targetStartYearMonth - 開始対象年月
   * @param rangeMonth - 取得する月数
   */
  public async Execute(
    repository: CustomerForecastRepository,
    baseBusinessId: string,
    targetStartYearMonth: IYearMonth,
    rangeMonth: number
  ): Promise<INetworkResult<ICustomerForecastTimeline, Error>> {
    try {
      const result = await repository.getTimeline(baseBusinessId, targetStartYearMonth.year, targetStartYearMonth.month, rangeMonth);

      switch (result.status.type) {
        case 'success':
          break;
        case 'error':
          throw result.status.error;
        default:
          throw new Error('Invalid status');
      }

      const resultData = BulkGetCustomerForecastTimelineAdapter.adapt(result.status.data.data);

      return {
        status: {
          type: 'success',
          data: resultData,
        },
      };
    } catch (error) {
      return {
        status: {
          type: 'error',
          error: Error('取得に失敗しました'),
        },
      };
    }
  }
}
